import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Form, Alert } from "react-bootstrap";
import Center from "react-center";
import Select from "react-select";
import * as Icons from "react-feather";
import moment from "moment";
import Axios from "axios";
import { urlAPI } from "Common";
import CanvasStep1 from "./CanvasStep1";

const initDataDokter = {
  count: 0,
  rows: [],
};

const doctorCardStyle = {
    width: "100%",
    maxWidth: "300px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    border: "1px solid #f0f0f0",
    borderRadius: "8px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginBottom: "1rem",
};

const selectedCardStyle = {
    border: "2px solid #28a745",
};

const imageContainerStyle = {
    position: "relative",
    overflow: "hidden",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
};

const doctorImageStyle = {
    width: "100%",
    display: "block",
    objectFit: "cover",
    height: "auto",
};

const doctorInfoStyle = {
    marginBottom: "0.5rem",
    color: "#555",
};

export default function Step2Page(props) {
  const {
    dataStep1,
    setDataStep1,
    selectorSBU,
    fetchSelectorUnit,
    selectorUnit,
    loadingUnit,
    dataStep2,
    setDataStep2,
    setMessageState,
    setShowFailed,
    setShowInfo,
    handleNext,
    setLoadingUnit,
    initStep2,
    dataBPJS,
    setDataBPJS,
    handlePrev,
    setUnitJenis3,
  } = props;

  const [dataDokter, setDataDokter] = useState(initDataDokter);
  const [loadingLoad, setLoadingLoad] = useState(false);
    const [selectedDokter, setSelectedDokter] = useState(null);
    const [selectedTime, setSelectedTime] = useState("");
  const [openCanvas, setOpenCanvas] = useState(false);

  const SPECIAL_H1_UNITS = [];
  const SPECIAL_TODAY_H1_UNITS = ["A62", "P48", "G16", "G17", "G18"];
  const SPECIAL_QUOTA_UNITS = [ "G16", "G17", "G18"];
  const isSpecialH1Unit = SPECIAL_H1_UNITS.includes(dataStep1?.unit);
  const isSpecialQuotaUnit = SPECIAL_QUOTA_UNITS.includes(dataStep1?.unit);
  const isSpecialTodayH1Unit = SPECIAL_TODAY_H1_UNITS.includes(dataStep1?.unit);
  const isG16Unit = dataStep1?.unit === "G16";
  const serverNow = moment();
  const registrationStartTime = moment().hour(8).minute(0).second(0).millisecond(0);
  const isSpecialH1Available = !isSpecialH1Unit || serverNow.isSameOrAfter(registrationStartTime);
  const JAM_BUKA = 8; // 08:00 WIB (jam server)
  const PESAN_BELUM_BUKA =
    "Pendaftaran online untuk poli ini dibuka mulai pukul 08:00 WIB. Silakan kembali lagi setelah pukul 08:00 WIB.";

  const getSpecialQuotaValue = (jadwal, type) => {
  const value = Number(
    type === "bpjs"
      ? jadwal?.KUOTABPJS ??
        jadwal?.kuotaBpjs ??
        jadwal?.kuotabpjs ??        // <-- tambahan: field asli dari backend
        jadwal?.KUOTAJKN ??
        jadwal?.kuotaJkn ??
        0
      : jadwal?.KUOTAUMUM ??
        jadwal?.kuotaUmum ??
        jadwal?.kuotaumum ??        // <-- tambahan: field asli dari backend
        jadwal?.KUOTANONJKN ??
        jadwal?.kuotaNonJkn ??
        0
  );
  return Number.isFinite(value) ? value : 0;
};

  const getScheduleQuotaLimit = (jadwal) => {
    const rawKuota = Number(jadwal?.kuota ?? 0);
    if (isSpecialQuotaUnit) {
      const kuotaUmum = getSpecialQuotaValue(jadwal, "umum");
      const kuotaBpjs = getSpecialQuotaValue(jadwal, "bpjs");
      return isG16Unit ? kuotaUmum : kuotaUmum + kuotaBpjs;
    }
    return rawKuota;
  };

  const getUsedQuota = (j) =>
    Number(j?.totalantrianbpjs ?? 0) + Number(j?.totalantrianumum ?? 0);

  const getSpecialQuotaStatus = (usedBpjs, usedUmum, quotaBpjs, quotaUmum) => {
    const safeUsedBpjs = Number(usedBpjs ?? 0);
    const safeUsedUmum = Number(usedUmum ?? 0);
    const safeQuotaBpjs = Number(quotaBpjs ?? 0);
    const safeQuotaUmum = Number(quotaUmum ?? 0);

    const calcStatus = (used, quota) => {
      const remaining = Math.max(quota - used, 0);
      return {
        full: quota <= 0 || used >= quota,
        remaining,
      };
    };

    const bpjsStatus = calcStatus(safeUsedBpjs, safeQuotaBpjs);
    const umumStatus = calcStatus(safeUsedUmum, safeQuotaUmum);

    if (isG16Unit) {
      return {
        bpjsFull: true,
        umumFull: umumStatus.full,
        isFull: umumStatus.full,
        sisaBpjs: 0,
        sisaUmum: umumStatus.remaining,
      };
    }

    return {
      bpjsFull: bpjsStatus.full,
      umumFull: umumStatus.full,
      isFull: bpjsStatus.full && umumStatus.full,
      sisaBpjs: bpjsStatus.remaining,
      sisaUmum: umumStatus.remaining,
    };
  };

  let hariIni = isSpecialTodayH1Unit
    ? moment().format("YYYY-MM-DD")
    : isSpecialH1Unit
    ? moment().add(1, "days").format("YYYY-MM-DD")
    : moment().format("YYYY-MM-DD");
  let maxHari = (isSpecialH1Unit || isSpecialTodayH1Unit)
    ? moment().add(1, "days").format("YYYY-MM-DD")
    : dataStep1?.sbu === "RSPG" && dataStep1.unit !== "P37"
    ? moment().add(30, "days").format("YYYY-MM-DD")
    : dataStep1?.sbu === "RSPG" && dataStep1.unit === "P37"
    ? moment().add(5, "days").format("YYYY-MM-DD")
    : moment().add(3, "days").format("YYYY-MM-DD");

 let hari_bpjs = dataStep1?.sbu === "RSPG" ? moment().add(2, "days").format("YYYY-MM-DD") : moment().add(3, "days").format("YYYY-MM-DD");

  // === SATU-SATUNYA sumber kebenaran validasi tanggal ===
  const isDateInRange = (d) =>
    typeof d === "string" &&
    moment(d, "YYYY-MM-DD", true).isValid() &&
    d >= hariIni &&
    d <= maxHari;

  const dateValid = isDateInRange(dataStep1?.date);
  const dateOutOfRange = !!dataStep1?.date && !dateValid;
  const pesanTanggal = `Pendaftaran bisa dilakukan H-1`;
  const PESAN_TANGGAL_TIDAK_VALID =
    "Tanggal kunjungan di luar rentang yang diperbolehkan. Silakan pilih ulang tanggal.";

    // const cekTanggalServer = () => {
    //     setLoadingLoad(true);
    //     Axios.get(urlAPI + "/public/regonline/cektanggal")
    //         .then((response) => {
    //             if (
    //                 moment(new Date()).format("YYYY-MM-DD") !==
    //                 response?.data?.result[0]?.Tanggal
    //             ) {
    //                 setMessageState("Tanggal Perangkat Tidak Sesuai Dengan Server");
    //                 setShowFailed(true);
    //                 setLoadingUnit(false);
    //                 setLoadingLoad(false);
    //             } else {
    //                 setDataStep2(initStep2);
    //                 fetchJadwalDokter();
    //             }
    //         })
    //         .catch((err) => {
    //             setMessageState(err?.response?.data?.message ?? err?.response);
    //             setShowFailed(true);
    //             setLoadingUnit(false);
    //             setLoadingLoad(false);
    //         });
    // };

    const cekTanggalServer = () => {
      // Gerbang utama: tanggal di luar rentang tidak boleh sampai ke server/fetch jadwal
      if (!isDateInRange(dataStep1?.date)) {
        setMessageState(PESAN_TANGGAL_TIDAK_VALID);
        setShowInfo(true);
        setDataDokter(initDataDokter);
        setSelectedDokter(null);
        setSelectedTime("");
        setLoadingLoad(false);
        return;
      }

      setLoadingLoad(true);
      Axios.get(urlAPI + "/public/regonline/cektanggal")
        .then((response) => {
          const serverRow = response?.data?.result?.[0];
          const kodeUnit = String(dataStep1?.unit ?? "").trim().toUpperCase();

          if (moment(new Date()).format("YYYY-MM-DD") !== serverRow?.Tanggal) {
            setMessageState("Tanggal Perangkat Tidak Sesuai Dengan Server");
            setShowFailed(true);
            setLoadingUnit(false);
            setLoadingLoad(false);
          } else if (
            SPECIAL_TODAY_H1_UNITS.includes(kodeUnit) &&
            Number(serverRow?.Jam) < JAM_BUKA
          ) {
            setMessageState(PESAN_BELUM_BUKA);
            setShowInfo(true);
            setDataDokter(initDataDokter);
            setSelectedDokter(null);
            setSelectedTime("");
            setLoadingLoad(false);
          } else {
            setDataStep2(initStep2);
            fetchJadwalDokter();
          }
        })
        .catch((err) => {
          setMessageState(err?.response?.data?.message ?? err?.response);
          setShowFailed(true);
          setLoadingUnit(false);
          setLoadingLoad(false);
        });
    };

    const fetchJadwalDokter = () => {
        setLoadingLoad(true);
        Axios.get(
            urlAPI +
            "/public/jadwaldokter/publictersedia?params=" +
            JSON.stringify({
                unit: dataStep1?.unit,
                day: moment(dataStep1?.date).day(),
                date: moment(dataStep1?.date).format("YYYY-MM-DD"),
                sbu: dataStep1?.sbu,
                klasifikasi: dataStep1?.registrationType,
            })
        )
            .then((response) => {
                if (response?.data?.result?.rows?.length > 0) {
                    const groupedDokter = {};
                    response.data.result.rows.forEach((jadwal) => {
                        const kodeDokter = jadwal?.kodedokter;
                        if (groupedDokter[kodeDokter]) {
                            groupedDokter[kodeDokter].jam.push(jadwal?.jam);
                            groupedDokter[kodeDokter].schedules.push(jadwal);
                            groupedDokter[kodeDokter].kuota.push(jadwal?.kuota);
                            groupedDokter[kodeDokter].kuotaUmum.push(getSpecialQuotaValue(jadwal, "umum"));
                            groupedDokter[kodeDokter].kuotaBpjs.push(getSpecialQuotaValue(jadwal, "bpjs"));
                            groupedDokter[kodeDokter].totalantrian.push(jadwal?.totalantrian);
                            groupedDokter[kodeDokter].totalantrianbpjs.push(jadwal?.totalantrianbpjs);
                            groupedDokter[kodeDokter].totalantrianumum.push(jadwal?.totalantrianumum);
                        } else {
                            groupedDokter[kodeDokter] = {
                                id: jadwal?.id,
                                kodedokter: kodeDokter,
                                namadokter: jadwal?.namadokter,
                                kodedokterbpjs: jadwal?.kodedokterbpjs,
                                kodeunitbpjs: jadwal?.kodeunitbpjs,
                                ruang: jadwal?.ruang,
                                schedules: [jadwal],
                                jam: [jadwal?.jam],
                                sesi: [jadwal?.sesi],
                                kuota: [jadwal?.kuota],
                                kuotaUmum: [getSpecialQuotaValue(jadwal, "umum")],
                                kuotaBpjs: [getSpecialQuotaValue(jadwal, "bpjs")],
                                totalantrian: [jadwal?.totalantrian],
                                totalantrianbpjs: [jadwal?.totalantrianbpjs],
                                totalantrianumum: [jadwal?.totalantrianumum],
                            };
                        }
                    });
                    setDataDokter({ rows: Object.values(groupedDokter) });
                } else {
                    setDataDokter(initDataDokter);
                }
                setLoadingLoad(false);
                setSelectedDokter(null);
                setSelectedTime("");
                setDataStep2({ ...dataStep2, sesi: null });
            })
            .catch((err) => {
                const message = err?.response?.message ?? err?.response?.data?.message;
                setMessageState(message);
                if (message === "No Data...") {
                    setShowFailed(true);
                } else {
                    setShowInfo(true);
                }
                setDataDokter(initDataDokter);
                setLoadingLoad(false);
            });
    };

    useEffect(() => {
        if (dataStep1?.sbu && dataStep1?.unit && isDateInRange(dataStep1?.date)) {
            cekTanggalServer();
        } else {
            // Tanggal belum valid / di luar rentang: kosongkan daftar dokter dan pilihan
            // supaya data lama dari tanggal sebelumnya tidak bisa dilanjutkan.
            setDataDokter(initDataDokter);
            setSelectedDokter(null);
            setSelectedTime("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataStep1?.sbu, dataStep1?.unit, dataStep1?.date]);

    const handlePilihDokter = (dokter) => {
        setSelectedDokter(dokter);
        setSelectedTime("");
        setDataStep2({ ...dataStep2, sesi: null });
    };

    const handleBatalPilihDokter = () => {
        setSelectedDokter(null);
        setSelectedTime("");
        setDataStep2({ ...dataStep2, sesi: null });
    };

    const handlePilihWaktu = (waktu) => {
        setSelectedTime(waktu);
        const selectedJadwal = selectedDokter?.schedules?.find(
            (schedule) => schedule.jam === waktu
        );
        if (selectedJadwal) {
            setDataStep2({ ...dataStep2, sesi: selectedJadwal?.sesi });
        } else {
            setDataStep2({ ...dataStep2, sesi: null });
        }
    };

      const handleLanjutkan = () => {
        // Guard terakhir sebelum ke step berikutnya
        if (!dateValid) {
          setMessageState(PESAN_TANGGAL_TIDAK_VALID);
          setShowInfo(true);
          return;
        }

        if (selectedDokter && selectedTime && dataStep2?.sesi) {
          const selectedJadwal = selectedDokter.schedules.find(
            (schedule) => schedule.jam === selectedTime
          );

          if (selectedJadwal) {
            if (isSpecialQuotaUnit) {
              const kuotaUmum = getSpecialQuotaValue(selectedJadwal, "umum");
              const kuotaBpjs = getSpecialQuotaValue(selectedJadwal, "bpjs");
              const { isFull, sisaBpjs, sisaUmum } = getSpecialQuotaStatus(
                Number(selectedJadwal?.totalantrianbpjs ?? 0),
                Number(selectedJadwal?.totalantrianumum ?? 0),
                kuotaBpjs,
                kuotaUmum
              );

              const hasAnyQuota = kuotaBpjs > 0 || kuotaUmum > 0;
              const hasZeroQuota = kuotaBpjs <= 0 && kuotaUmum <= 0;
              const totalAvailableQuota = isG16Unit ? sisaUmum : sisaBpjs + sisaUmum;

              if (hasZeroQuota) {
                setMessageState(
                  "Tidak Ada Kuota. Jadwal ini tidak bisa digunakan untuk pendaftaran."
                );
                setShowInfo(true);
                return;
              }

              if (totalAvailableQuota <= 0 || (isG16Unit && kuotaUmum <= 0)) {
                setMessageState(
                  isG16Unit
                    ? "Kuota Umum/Asuransi untuk poli G16 sudah habis. Tidak bisa melanjutkan pendaftaran."
                    : "Kuota untuk unit ini sudah habis sesuai data backend. Tidak bisa melanjutkan pendaftaran."
                );
                setShowInfo(true);
                return;
              }

              if (hasAnyQuota && isG16Unit) {
                if (isFull) {
                  setMessageState(
                    "Kuota khusus G16 sudah penuh sesuai kuota yang tersedia di backend. BPJS tidak tersedia untuk poli ini."
                  );
                  setShowInfo(true);
                  return;
                }
              } else if (hasAnyQuota && isFull) {
                setMessageState(
                  "Kuota khusus unit ini sudah penuh sesuai kuota backend."
                );
                setShowInfo(true);
                return;
              }
            } else {
              const scheduleQuotaLimit = getScheduleQuotaLimit(selectedJadwal);
              if (scheduleQuotaLimit > 0 && getUsedQuota(selectedJadwal) >= scheduleQuotaLimit) {
                setMessageState("Kuota untuk jadwal ini sudah penuh.");
                setShowInfo(true);
                return;
              }
            }

            setDataStep2({
              ...dataStep2,
              idjadwal: selectedJadwal?.id,
              kodedokter: selectedJadwal?.kodedokter,
              namadokter: selectedJadwal?.namadokter,
              kodedokterbpjs: selectedJadwal?.kodedokterbpjs,
              kodeunitbpjs: selectedJadwal?.kodeunitbpjs,
              ruang: selectedJadwal?.ruang,
              jam: selectedTime,
              sesi: selectedJadwal?.sesi,
            });

            setDataBPJS({
              ...dataBPJS,
              kodedokterbpjs: selectedJadwal?.kodedokterbpjs,
              kodeunitbpjs: selectedJadwal?.kodeunitbpjs,
              kuota: selectedJadwal?.kuota,
            });

            handleNext();
          } else {
            setMessageState("Jadwal tidak ditemukan.");
            setShowInfo(true);
          }
        } else {
          setMessageState("Mohon pilih dokter dan jam terlebih dahulu.");
          setShowInfo(true);
        }
      };

    const isLanjutkanDisabled = !dateValid || !selectedDokter || !selectedTime || !dataStep2?.sesi || loadingLoad;

    return (
        <>
          <Card.Title>
            <strong>(2/4) Pilih Dokter dan Jam</strong>
          </Card.Title>
          <br />
          {/* Tombol Ubah Tujuan & Tanggal untuk Mobile */}
          <div className="d-grid gap-2 d-block d-md-none mb-3">
            <Button
              variant="outline-warning"
              disabled={loadingLoad}
              onClick={() => {
                setOpenCanvas(true);
              }}
            >
              {loadingLoad ? "Loading..." : <Icons.Edit size={16} className="align-middle me-2" />} Ubah Tujuan dan Tanggal
            </Button>
          </div>
    
            {/* Form Pemilihan Tujuan & Tanggal untuk Desktop */}
            <Card className="d-none d-md-block mb-4">
                <Card.Body>
                    <Form>
                        <Row className="align-items-end">
                            <Col lg="3" md="6" className="mb-3">
                                <Form.Group>
                                    <Form.Label>Rumah Sakit Tujuan</Form.Label>
                                    <Select
                                        styles={{
                                            color: "black",
                                        }}
                                        id="sbu"
                                        name="sbu"
                                        options={selectorSBU}
                                        isDisabled={loadingLoad || !!dataStep1?.sbu}
                                        value={selectorSBU.find(
                                            (find) => find?.value === dataStep1?.sbu
                                        )}
                                        onChange={(e) => {
                                            fetchSelectorUnit(e.value);
                                            setDataStep1({
                                                ...dataStep1,
                                                sbu: e.value,
                                                sbuname: e.label,
                                                unit: null,
                                                unitname: null,
                                                date: null,
                                            });
                                            setDataDokter(initDataDokter);
                                            setSelectedDokter(null);
                                            setSelectedTime("");
                                            setDataStep2(initStep2);
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg="3" md="6" className="mb-3">
                                <Form.Group>
                                    <Form.Label>Poli/Unit Tujuan</Form.Label>
                                    {dataStep1?.sbu ? (
                                        <Select
                                            styles={{
                                                color: "black",
                                                }}
                                            id="unit"
                                            name="unit"
                                            options={selectorUnit}
                                            isDisabled={loadingLoad || !dataStep1?.sbu}
                                            isLoading={loadingUnit}
                                            value={selectorUnit.find(
                                                (find) => find?.value === dataStep1?.unit
                                            )}
                                            onChange={(e) => {
                                                setDataStep1({
                                                    ...dataStep1,
                                                    unit: e.value,
                                                    unitname: e.label,
                                                    date: null,
                                                });
                                                setUnitJenis3(e.jenis3);
                                                setDataDokter(initDataDokter);
                                                setSelectedDokter(null);
                                                setSelectedTime("");
                                                setDataStep2(initStep2);
                                            }}
                                        />
                                    ) : (
                                        <Form.Control
                                            type="text"
                                            value="Pilih Rumah Sakit Tujuan Terlebih Dahulu..."
                                            disabled
                                        />
                                    )}
                                </Form.Group>
                            </Col>
                            <Col lg="3" md="6" className="mb-3">
                                <Form.Group>
                                    <Form.Label>Tanggal</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={dataStep1?.date || ""}
                                        onChange={(e) => setDataStep1({ ...dataStep1, date: e.target.value || "" })}
                                        min={hariIni}
                                        max={maxHari}
                                        isInvalid={dateOutOfRange}
                                        disabled={loadingLoad || !dataStep1?.unit || (isSpecialH1Unit && !isSpecialH1Available)}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {pesanTanggal}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col lg="3" md="6" className="mb-3">
                                <Button
                                    variant="warning"
                                    onClick={cekTanggalServer}
                                    disabled={
                                        !dataStep1?.sbu ||
                                        !dataStep1?.unit ||
                                        !dateValid ||
                                        (isSpecialH1Unit && !isSpecialH1Available) ||
                                        loadingLoad
                                    }
                                >
                                    {loadingLoad ? (
                                        <Icons.Loader className="spin" size={16} />
                                    ) : dateOutOfRange ? (
                                        "Tanggal Tidak Valid"
                                    ) : (
                                        "Cari Dokter"
                                    )}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>
    
          {loadingLoad ? (
            <div className="text-center">
              <Icons.Loader className="spin" size={36} />
              <p className="mt-2">Memuat jadwal dokter...</p>
            </div>
          ) : (
            <Row className="row-cols-1 row-cols-sm-3 g-4">
              {dataDokter?.rows?.map((dokter) => (
                <Col key={dokter?.kodedokter} className="d-flex justify-content-center">
                  <Card style={{ ...doctorCardStyle, ...(selectedDokter?.kodedokter === dokter?.kodedokter ? selectedCardStyle : {}) }}>
                    <div style={imageContainerStyle}>
                      <Card.Img
                        variant="top"
                        src={`/assets/img/doctor/${dokter?.kodedokter?.trim()}.webp`}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = "/assets/img/doctor/default-doctor.svg";
                        }}
                        style={doctorImageStyle}
                      />
                    </div>
                    <Card.Body className="d-flex flex-column justify-content-between">
                      <div>
                        <Card.Title className="text-center mb-2" style={{ minHeight: "50px" }}>
                          {dokter?.namadokter}
                        </Card.Title>
                        <Card.Text className="text-center">
                          <p style={doctorInfoStyle}>
                            <Icons.Home size={16} className="align-middle me-1" />
                            <strong>{dokter?.ruang}</strong>
                          </p>
                        </Card.Text>
                      </div>
                      <div className="d-grid gap-2">
                        <Button
                          variant={selectedDokter?.kodedokter === dokter?.kodedokter ? "outline-danger" : "primary"}
                          onClick={() => {
                            selectedDokter?.kodedokter === dokter?.kodedokter
                              ? handleBatalPilihDokter()
                              : handlePilihDokter(dokter);
                          }}
                        >
                          {selectedDokter?.kodedokter === dokter?.kodedokter ? "Batal Pilih Dokter" : "Pilih Dokter"}
                        </Button>
                      </div>
    
                      {selectedDokter?.kodedokter === dokter?.kodedokter && dokter?.jam?.length > 0 && (
                      <div className="mt-3 p-3 rounded-3 shadow-sm border border-light bg-light">
                        {/* <Form.Label className="fw-bold text-dark mb-3 d-block">
                          🕒 Pilih Jam :
                        </Form.Label> */}
                          
                          <Row className="g-2">
                            {dokter.jam.map((time, index) => {
                              let isScheduleFull = false;
                              let buttonLabel = time;
                              let quotaCaption = null;
                              let buttonVariant = selectedTime === time ? "warning" : "outline-success";

                              if (isSpecialQuotaUnit) {
                                const usedBpjs = Number(dokter?.totalantrianbpjs?.[index] ?? 0);
                                const usedUmum = Number(dokter?.totalantrianumum?.[index] ?? 0);
                                const kuotaBpjs = Number(dokter?.kuotaBpjs?.[index] ?? 0);
                                const kuotaUmum = Number(dokter?.kuotaUmum?.[index] ?? 0);
                                const { bpjsFull, umumFull, isFull, sisaBpjs, sisaUmum } = getSpecialQuotaStatus(
                                  usedBpjs,
                                  usedUmum,
                                  kuotaBpjs,
                                  kuotaUmum
                                );

                                const hasZeroQuota = kuotaBpjs <= 0 && kuotaUmum <= 0;
                                isScheduleFull = isFull;

                                if (hasZeroQuota) {
                                  buttonLabel = "Tidak Ada Kuota";
                                  buttonVariant = "secondary";
                                  quotaCaption = "Kuota untuk jadwal ini belum tersedia.";
                                  isScheduleFull = true;
                                } else if (isG16Unit) {
                                  if (isFull) {
                                    buttonLabel = "Kuota Penuh";
                                    buttonVariant = "danger";
                                    quotaCaption = `Kuota Umum/Asuransi sudah penuh: ${sisaUmum} tersisa`;
                                  } else {
                                    quotaCaption = `Sisa Umum/Asuransi: ${sisaUmum}`;
                                  }
                                } else if (isFull) {
                                  buttonLabel = "Kuota Penuh";
                                  buttonVariant = "danger";
                                } else if (bpjsFull) {
                                  quotaCaption = `Kuota BPJS penuh — tersisa Umum/Asuransi: ${sisaUmum}`;
                                  buttonVariant = selectedTime === time ? "warning" : "outline-info";
                                } else if (umumFull) {
                                  quotaCaption = `Kuota Umum/Asuransi penuh — tersisa BPJS: ${sisaBpjs}`;
                                  buttonVariant = selectedTime === time ? "warning" : "outline-info";
                                } else {
                                  quotaCaption = `Sisa Kuota: BPJS ${sisaBpjs} · Umum/Asuransi ${sisaUmum}`;
                                }
                              } else {
                                const jadwal = dokter.schedules[index];
                                  const scheduleQuotaLimit = getScheduleQuotaLimit(jadwal);
                                  isScheduleFull =
                                  scheduleQuotaLimit > 0 && getUsedQuota(jadwal) >= scheduleQuotaLimit;
                                  buttonLabel = isScheduleFull ? "Kuota Penuh" : time;
                                  buttonVariant = isScheduleFull ? "danger" : buttonVariant;
                              }

                              return (
                                <Col key={index} xs={6} sm={4} md={3} lg={12}>
                                  <Button
                                    variant={buttonVariant}
                                    onClick={() => handlePilihWaktu(time)}
                                    size="sm"
                                    className="w-100 rounded-pill px-2 text-center"
                                    style={{ transition: "all 0.2s", fontWeight: "600" }}
                                    disabled={isScheduleFull}
                                  >
                                    {buttonLabel}
                                  </Button>
                                  {isSpecialQuotaUnit && quotaCaption && (
                                    <div className="text-center" style={{ fontSize: "10px", color: "#6c757d", marginTop: "2px" }}>
                                      {quotaCaption}
                                    </div>
                                  )}
                                </Col>
                              );
                            })}
                          </Row>
                        </div>
                      )}
                          {/* {dokter.jam.every((time) => moment(time, "HH:mm").diff(moment(), "minutes") <= 60) && (
                            <Alert variant="danger" className="mt-3">
                              Semua pilihan jam untuk jadwal dokter ini sudah terlewat atau tidak tersedia.
                            </Alert>
                          )} */}
                    </Card.Body>
                    
                    {selectedDokter?.kodedokter === dokter?.kodedokter && selectedTime && dataStep2?.sesi && (
                      <Card.Footer className="text-center">
                        <Button variant="success" onClick={handleLanjutkan} disabled={!dateValid} className="w-100">
                          Lanjutkan
                        </Button>
                      </Card.Footer>
                    )}
                  </Card>
                </Col>
              ))}
              {dataDokter?.rows?.length === 0 && (
                <Col xs={12} className="text-center">
                  <Alert variant="info">Tidak ada jadwal dokter yang tersedia pada tanggal dan unit yang dipilih.</Alert>
                </Col>
              )}
            </Row>
          )}
          <br className="d-none d-md-block" />
          <div className="d-none d-md-flex justify-content-between">
            <Button
              variant="outline-secondary"
              onClick={handlePrev}
              disabled={loadingLoad}
            >
              <Icons.ArrowLeft size={16} className="align-middle me-2" /> Kembali
            </Button>
            {/* <Button
              variant="success"
              onClick={handleLanjutkan}
              disabled={isLanjutkanDisabled}
            >
              Lanjutkan <Icons.ArrowRight size={16} className="align-middle ms-2" />
            </Button> */}
          </div>
    
          {/* Tombol Kembali dan Lanjutkan untuk Mobile */}
          <div className="d-grid gap-2 d-md-none mt-2">
            <Button
              variant="outline-secondary"
              onClick={handlePrev}
              disabled={loadingLoad}
            >
              <Icons.ArrowLeft size={16} className="align-middle me-2" /> Kembali
            </Button>
            {/* <Button
              variant="success"
              onClick={handleLanjutkan}
              disabled={isLanjutkanDisabled}
            >
              Lanjutkan <Icons.ArrowRight size={16} className="align-middle ms-2" />
            </Button> */}
          </div>
    
          {/* Mobile Canvas */}
          <CanvasStep1
            dataStep1={dataStep1}
            setDataStep1={setDataStep1}
            selectorSBU={selectorSBU}
            fetchSelectorUnit={(event) => {
              setLoadingUnit(true);
              fetchSelectorUnit(event);
            }}
            selectorUnit={selectorUnit}
            loadingUnit={loadingUnit}
            openCanvas={openCanvas}
            setOpenCanvas={setOpenCanvas}
            // fetchJadwalDokter={fetchJadwalDokter}
            fetchJadwalDokter={cekTanggalServer}
            setLoadingLoad={setLoadingLoad}
            setDataStep2={setDataStep2}
            initStep2={initStep2}
            setUnitJenis3={setUnitJenis3}
          />
        </>
      );
    }